module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notificationBox",
    class: {
      'ok': _vm.type === 'ok', 'warning': _vm.type === 'warning'
    }
  }, [_c('div', {
    staticClass: "content content-icon"
  }, [_c('i', {
    class: {
      'el-icon-success': _vm.type === 'ok', 'el-icon-warning': _vm.type === 'warning'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content content-text"
  }, [_c('label', [_vm._v(_vm._s(_vm.text))])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-54364d91", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54364d91"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReschedulingPage/NotificationBox.vue
// module id = 714
// module chunks = 0